var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { YES_OR_NO_EMERGENCY_SERVICE_NEEDED } from '@shared/constants/robberyConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
let RobberyHouseIsEmergencyServiceNeededQuestion = class RobberyHouseIsEmergencyServiceNeededQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoEmergencyServiceNeeded = YES_OR_NO_EMERGENCY_SERVICE_NEEDED;
    }
    updateClaim(emergencyServiceNeeded) {
        this.updateAndSaveQualification({
            qualificationPayload: { emergencyServiceNeeded },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.robbery.emergency.is_needed.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.robbery.emergency.is_needed.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.emergencyServiceNeeded === null) {
            return null;
        }
        return this.qualification.emergencyServiceNeeded
            ? this.$tc('claim.qualification.robbery.emergency.answer.yes')
            : this.$tc('claim.qualification.robbery.emergency.answer.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], RobberyHouseIsEmergencyServiceNeededQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], RobberyHouseIsEmergencyServiceNeededQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], RobberyHouseIsEmergencyServiceNeededQuestion.prototype, "updateAndSaveQualification", void 0);
RobberyHouseIsEmergencyServiceNeededQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], RobberyHouseIsEmergencyServiceNeededQuestion);
export default RobberyHouseIsEmergencyServiceNeededQuestion;
